module.exports = __webpack_public_path__ + "img/Detection_Line_2_20px_Icon_black.7cc9935f.svg";